/*
 * @Author: your name
 * @Date: 2019-11-26 09:28:09
 * @LastEditTime: 2019-11-29 18:27:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/api/class/assess.js
 */
import { post } from "../http";

export default {
  //获取测评科目
  getSubjects: params => {
    return post(`/index.php?r=mobileapp/specialPlanExam/GetSubjects`, params);
  },
  //根据科目获取年级
  getGrade: params => {
    return post(`/index.php?r=mobileapp/specialPlanExam/GetGrades`, params);
  },
  // 获取测评列表
  getSpecialPlanList: params => {
    return post(
      `/index.php?r=mobileapp/specialPlanExam/GetSpecialPlanList`,
      params
    );
  },
  // 开始测评
  postStartExam: params => {
    return post(`/index.php?r=mobileapp/specialPlanExam/StartExam`, params);
  },
  // 获取测评题目
  getExamSubject: params => {
    return post(
      `/index.php?r=mobileapp/specialPlanExam/GetExamTagQuestion`,
      params
    );
  },
  // 测评提交
  postAnswer: params => {
    return post(`/index.php?r=mobileapp/specialPlanExam/PostAnswer`, params);
  },
  // 做题记录
  getExamQuestionLog: params => {
    return post(
      `/index.php?r=mobileapp/specialPlanExam/GetExamQuestionLog`,
      params
    );
  }
};
